import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest, IQueryResultSettings } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './AlternateItemsEntity.g';
// import * as Msdyn365 from '@msdyn365-commerce/core';


function getFitmentFiltersDataBytypeQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function getFitmentFiltersDataBytypeInput(
  queryResultSettings: IQueryResultSettings, fitmentSearchCriteria:
    DataServiceEntities.IGCFitmentSearchCriteria
): IDataServiceRequest {
  const query = getFitmentFiltersDataBytypeQuery().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'GetFitmentFiltersDataBytype',
    true,
    DataServiceEntities.GCFitmentFilterDataEntityExtensionClass
    ,
    'true',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGCFitmentFilterDataEntity' },
    {
      fitmentSearchCriteria: fitmentSearchCriteria
    }
  );
}

export function getFitmentFiltersDataBytypeAsync(
  context: IContext, fitmentSearchCriteria:
    DataServiceEntities.IGCFitmentSearchCriteria
): AsyncResult<DataServiceEntities.IGCFitmentFilterDataEntity[]> {
  const request = getFitmentFiltersDataBytypeInput(
    context.queryResultSettings || {}, fitmentSearchCriteria);
  return callActionOrExecute<DataServiceEntities.IGCFitmentFilterDataEntity[]>(request, context.callerContext);
}